export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = "http://130.61.148.139:8003";
// export const API_URL = "https://poolinsapptest.oapps.net";
export const TOKEN =
  sessionStorage.getItem("n") +
  "." +
  sessionStorage.getItem("t") +
  "." +
  sessionStorage.getItem("k");
export const LOGGED_USER = JSON.parse(sessionStorage.getItem("user"));

export const ITT_UNITS = [
  { value: "JOURS", label: "Jours" },
  { value: "SEMAINES", label: "Semaines" },
  { value: "MOIS", label: "Mois" },
];

export const PARAMETERS = {
  accessoires: "ACCESSOIRES",
  marque: "MARQUE",
  usage: "USAGE",
  carosserie: "CAROSSERIE",
  taxe: "TAXE",
  dureeMaxSuspension: "DUREE_MAX_SUSPENSION",
  dureeNonSuspension: "DUREE_NON_SUSPENSION",
  typeProfil: "TYPE_PROFIL",
  commission: "COMMISSION",
  banque: "BANQUE",
  natureActe: "NATURE_ACTE",
  prejudice: "PREJUDICE",
  causeSinistre: "CAUSE_SINISTRE",
  profession: "PROFESSION",
  ville: "VILLE",
  tauxCommission: "TAUX_COMMISSION",
  typeAttestation: "TYPE_ATTESTATION",
  motifRevision: "MOTIF_REVISION",
  motifAnnulationCheque: "MOTIF_ANNULATION_CHEQUE",
  motifReglement: "MOTIF_REGLEMENT",
  formuleCloture: "FORMULE_CLOTURE",
  observationEncaissement: "OBSERVATION_ENCAISSEMENT",
};

export const CORRESPONDANCE_TAUX_IP = [
  {
    tauxIP: { min: 0, max: 5 },
    age: {
      Moins_de_15_ans: 6,
      De_15_a_19_ans: 6,
      De_20_a_24_ans: 6,
      De_25_a_29_ans: 6,
      De_30_a_39_ans: 6,
      De_40_a_59_ans: 5,
      De_60_a_69_ans: 5,
      Soixante_dix_ans_et_plus: 5
    }
  },
  {
    tauxIP: { min: 6, max: 10 },
    age: {
      Moins_de_15_ans: 12,
      De_15_a_19_ans: 12,
      De_20_a_24_ans: 12,
      De_25_a_29_ans: 12,
      De_30_a_39_ans: 12,
      De_40_a_59_ans: 12,
      De_60_a_69_ans: 10,
      Soixante_dix_ans_et_plus: 10
    }
  },
  {
    tauxIP: { min: 11, max: 15 },
    age: {
      Moins_de_15_ans: 14,
      De_15_a_19_ans: 14,
      De_20_a_24_ans: 14,
      De_25_a_29_ans: 14,
      De_30_a_39_ans: 14,
      De_40_a_59_ans: 12,
      De_60_a_69_ans: 10,
      Soixante_dix_ans_et_plus: 10
    }
  },
  {
    tauxIP: { min: 16, max: 20 },
    age: {
      Moins_de_15_ans: 16,
      De_15_a_19_ans: 16,
      De_20_a_24_ans: 14,
      De_25_a_29_ans: 14,
      De_30_a_39_ans: 14,
      De_40_a_59_ans: 12,
      De_60_a_69_ans: 12,
      Soixante_dix_ans_et_plus: 12
    }
  },
  {
    tauxIP: { min: 21, max: 30 },
    age: {
      Moins_de_15_ans: 17,
      De_15_a_19_ans: 17,
      De_20_a_24_ans: 16,
      De_25_a_29_ans: 16,
      De_30_a_39_ans: 16,
      De_40_a_59_ans: 14,
      De_60_a_69_ans: 14,
      Soixante_dix_ans_et_plus: 12
    }
  },
  {
    tauxIP: { min: 31, max: 40 },
    age: {
      Moins_de_15_ans: 18,
      De_15_a_19_ans: 18,
      De_20_a_24_ans: 17,
      De_25_a_29_ans: 17,
      De_30_a_39_ans: 16,
      De_40_a_59_ans: 14,
      De_60_a_69_ans: 14,
      Soixante_dix_ans_et_plus: 13
    }
  },
  {
    tauxIP: { min: 41, max: 50 },
    age: {
      Moins_de_15_ans: 18,
      De_15_a_19_ans: 18,
      De_20_a_24_ans: 18,
      De_25_a_29_ans: 17,
      De_30_a_39_ans: 17,
      De_40_a_59_ans: 16,
      De_60_a_69_ans: 15,
      Soixante_dix_ans_et_plus: 13
    }
  },
  {
    tauxIP: { min: 51, max: 70 },
    age: {
      Moins_de_15_ans: 19,
      De_15_a_19_ans: 19,
      De_20_a_24_ans: 19,
      De_25_a_29_ans: 19,
      De_30_a_39_ans: 18,
      De_40_a_59_ans: 17,
      De_60_a_69_ans: 16,
      Soixante_dix_ans_et_plus: 14
    }
  },
  {
    tauxIP: { min: 71, max: 90 },
    age: {
      Moins_de_15_ans: 25,
      De_15_a_19_ans: 20,
      De_20_a_24_ans: 20,
      De_25_a_29_ans: 19,
      De_30_a_39_ans: 19,
      De_40_a_59_ans: 18,
      De_60_a_69_ans: 17,
      Soixante_dix_ans_et_plus: 15
    }
  },
  {
    tauxIP: { min: 91, max: 100 },
    age: {
      Moins_de_15_ans: 29,
      De_15_a_19_ans: 24,
      De_20_a_24_ans: 24,
      De_25_a_29_ans: 22,
      De_30_a_39_ans: 22,
      De_40_a_59_ans: 20,
      De_60_a_69_ans: 19,
      Soixante_dix_ans_et_plus: 18
    }
  }
];

export const BAREME_CAPITALISATION = {
  FEMININ: [
    { age: 0, prixDeRente: 15.065 },
    { age: 1, prixDeRente: 15.077 },
    { age: 2, prixDeRente: 15.084 },
    { age: 3, prixDeRente: 15.081 },
    { age: 4, prixDeRente: 15.061 },
    { age: 5, prixDeRente: 15.048 },
    { age: 6, prixDeRente: 15.038 },
    { age: 7, prixDeRente: 15.029 },
    { age: 8, prixDeRente: 15.019 },
    { age: 9, prixDeRente: 14.997 },
    { age: 10, prixDeRente: 14.976 },
    { age: 11, prixDeRente: 14.957 },
    { age: 12, prixDeRente: 14.933 },
    { age: 13, prixDeRente: 14.904 },
    { age: 14, prixDeRente: 14.876 },
    { age: 15, prixDeRente: 14.848 },
    { age: 16, prixDeRente: 14.818 },
    { age: 17, prixDeRente: 14.787 },
    { age: 18, prixDeRente: 14.755 },
    { age: 19, prixDeRente: 14.721 },
    { age: 20, prixDeRente: 14.686 },
    { age: 21, prixDeRente: 14.650 },
    { age: 22, prixDeRente: 14.606 },
    { age: 23, prixDeRente: 14.563 },
    { age: 24, prixDeRente: 14.529 },
    { age: 25, prixDeRente: 14.485 },
    { age: 26, prixDeRente: 14.440 },
    { age: 27, prixDeRente: 14.388 },
    { age: 28, prixDeRente: 14.336 },
    { age: 29, prixDeRente: 14.281 },
    { age: 30, prixDeRente: 14.223 },
    { age: 31, prixDeRente: 14.163 },
    { age: 32, prixDeRente: 14.099 },
    { age: 33, prixDeRente: 14.033 },
    { age: 34, prixDeRente: 13.961 },
    { age: 35, prixDeRente: 13.886 },
    { age: 36, prixDeRente: 13.807 },
    { age: 37, prixDeRente: 13.725 },
    { age: 38, prixDeRente: 13.636 },
    { age: 39, prixDeRente: 13.544 },
    { age: 40, prixDeRente: 13.448 },
    { age: 41, prixDeRente: 13.348 },
    { age: 42, prixDeRente: 13.240 },
    { age: 43, prixDeRente: 13.128 },
    { age: 44, prixDeRente: 13.013 },
    { age: 45, prixDeRente: 12.895 },
    { age: 46, prixDeRente: 12.760 },
    { age: 47, prixDeRente: 12.625 },
    { age: 48, prixDeRente: 12.485 },
    { age: 49, prixDeRente: 12.339 },
    { age: 50, prixDeRente: 12.186 },
    { age: 51, prixDeRente: 12.026 },
    { age: 52, prixDeRente: 11.868 },
    { age: 53, prixDeRente: 11.509 },
    { age: 54, prixDeRente: 11.334 },
    { age: 55, prixDeRente: 11.130 },
    { age: 56, prixDeRente: 10.931 },
    { age: 57, prixDeRente: 10.725 },
    { age: 58, prixDeRente: 10.518 },
    { age: 59, prixDeRente: 10.293 },
    { age: 60, prixDeRente: 10.067 },
    { age: 61, prixDeRente: 9.840 },
    { age: 62, prixDeRente: 9.597 },
    { age: 63, prixDeRente: 9.352 },
    { age: 64, prixDeRente: 9.101 },
    { age: 65, prixDeRente: 8.848 },
    { age: 66, prixDeRente: 8.588 },
    { age: 67, prixDeRente: 8.324 },
    { age: 68, prixDeRente: 8.056 },
    { age: 69, prixDeRente: 7.784 },
    { age: 70, prixDeRente: 7.509 },
    { age: 71, prixDeRente: 7.232 },
    { age: 72, prixDeRente: 6.953 },
    { age: 73, prixDeRente: 6.673 },
    { age: 74, prixDeRente: 6.391 },
    { age: 75, prixDeRente: 6.110 },
    { age: 76, prixDeRente: 5.829 },
    { age: 77, prixDeRente: 5.551 },
    { age: 78, prixDeRente: 5.275 },
    { age: 79, prixDeRente: 5.001 },
    { age: 80, prixDeRente: 4.731 },
    { age: 81, prixDeRente: 4.466 },
    { age: 82, prixDeRente: 4.205 },
    { age: 83, prixDeRente: 3.951 },
    { age: 84, prixDeRente: 3.701 },
    { age: 85, prixDeRente: 3.459 },
    { age: 86, prixDeRente: 3.224 },
    { age: 87, prixDeRente: 2.997 },
    { age: 88, prixDeRente: 2.778 },
    { age: 89, prixDeRente: 2.567 },
    { age: 90, prixDeRente: 2.365 },
    { age: 91, prixDeRente: 2.173 },
    { age: 92, prixDeRente: 1.989 },
    { age: 93, prixDeRente: 1.815 },
    { age: 94, prixDeRente: 1.650 },
    { age: 95, prixDeRente: 1.494 },
    { age: 96, prixDeRente: 1.348 },
    { age: 97, prixDeRente: 1.210 },
    { age: 98, prixDeRente: 1.082 },
    { age: 99, prixDeRente: 0.963 },
    { age: 100, prixDeRente: 0.851 },
    { age: 101, prixDeRente: 0.749 },
    { age: 102, prixDeRente: 0.655 },
    { age: 103, prixDeRente: 0.570 },
    { age: 104, prixDeRente: 0.493 },
    { age: 105, prixDeRente: 0.424 },
    { age: 106, prixDeRente: 0.362 },
    { age: 107, prixDeRente: 0.307 },
    { age: 108, prixDeRente: 0.258 },
    { age: 109, prixDeRente: 0.216 },
    { age: 110, prixDeRente: 0.180 },
    { age: 111, prixDeRente: 0.149 },
    { age: 112, prixDeRente: 0.123 },
    { age: 113, prixDeRente: 0.101 },
    { age: 114, prixDeRente: 0.082 },
    { age: 115, prixDeRente: 0.066 },
    { age: 116, prixDeRente: 0.053 },
    { age: 117, prixDeRente: 0.042 },
    { age: 118, prixDeRente: 0.033 },
    { age: 119, prixDeRente: 0.026 },
    { age: 120, prixDeRente: 0.020 }
  ],
  MASCULIN: [
    { age: 0, prixDeRente: 14.904 },
    { age: 1, prixDeRente: 14.910 },
    { age: 2, prixDeRente: 14.915 },
    { age: 3, prixDeRente: 14.919 },
    { age: 4, prixDeRente: 14.915 },
    { age: 5, prixDeRente: 14.881 },
    { age: 6, prixDeRente: 14.861 },
    { age: 7, prixDeRente: 14.835 },
    { age: 8, prixDeRente: 14.807 },
    { age: 9, prixDeRente: 14.777 },
    { age: 10, prixDeRente: 14.744 },
    { age: 11, prixDeRente: 14.709 },
    { age: 12, prixDeRente: 14.671 },
    { age: 13, prixDeRente: 14.632 },
    { age: 14, prixDeRente: 14.588 },
    { age: 15, prixDeRente: 14.543 },
    { age: 16, prixDeRente: 14.497 },
    { age: 17, prixDeRente: 14.450 },
    { age: 18, prixDeRente: 14.401 },
    { age: 19, prixDeRente: 14.353 },
    { age: 20, prixDeRente: 14.304 },
    { age: 21, prixDeRente: 14.253 },
    { age: 22, prixDeRente: 14.200 },
    { age: 23, prixDeRente: 14.144 },
    { age: 24, prixDeRente: 14.085 },
    { age: 25, prixDeRente: 14.025 },
    { age: 26, prixDeRente: 13.959 },
    { age: 27, prixDeRente: 13.891 },
    { age: 28, prixDeRente: 13.818 },
    { age: 29, prixDeRente: 13.746 },
    { age: 30, prixDeRente: 13.658 },
    { age: 31, prixDeRente: 13.571 },
    { age: 32, prixDeRente: 13.484 },
    { age: 33, prixDeRente: 13.389 },
    { age: 34, prixDeRente: 13.284 },
    { age: 35, prixDeRente: 13.180 },
    { age: 36, prixDeRente: 13.076 },
    { age: 37, prixDeRente: 12.968 },
    { age: 38, prixDeRente: 12.839 },
    { age: 39, prixDeRente: 12.716 },
    { age: 40, prixDeRente: 12.588 },
    { age: 41, prixDeRente: 12.455 },
    { age: 42, prixDeRente: 12.316 },
    { age: 43, prixDeRente: 12.172 },
    { age: 44, prixDeRente: 12.022 },
    { age: 45, prixDeRente: 11.869 },
    { age: 46, prixDeRente: 11.709 },
    { age: 47, prixDeRente: 11.544 },
    { age: 48, prixDeRente: 11.373 },
    { age: 49, prixDeRente: 11.196 },
    { age: 50, prixDeRente: 11.016 },
    { age: 51, prixDeRente: 10.829 },
    { age: 52, prixDeRente: 10.637 },
    { age: 53, prixDeRente: 10.440 },
    { age: 54, prixDeRente: 10.237 },
    { age: 55, prixDeRente: 10.030 },
    { age: 56, prixDeRente: 9.818 },
    { age: 57, prixDeRente: 9.602 },
    { age: 58, prixDeRente: 9.381 },
    { age: 59, prixDeRente: 9.158 },
    { age: 60, prixDeRente: 8.928 },
    { age: 61, prixDeRente: 8.696 },
    { age: 62, prixDeRente: 8.461 },
    { age: 63, prixDeRente: 8.223 },
    { age: 64, prixDeRente: 7.983 },
    { age: 65, prixDeRente: 7.741 },
    { age: 66, prixDeRente: 7.498 },
    { age: 67, prixDeRente: 7.254 },
    { age: 68, prixDeRente: 7.000 },
    { age: 69, prixDeRente: 6.756 },
    { age: 70, prixDeRente: 6.533 },
    { age: 71, prixDeRente: 6.302 },
    { age: 72, prixDeRente: 6.046 },
    { age: 73, prixDeRente: 5.808 },
    { age: 74, prixDeRente: 5.577 },
    { age: 75, prixDeRente: 5.351 },
    { age: 76, prixDeRente: 5.132 },
    { age: 77, prixDeRente: 4.921 },
    { age: 78, prixDeRente: 4.720 },
    { age: 79, prixDeRente: 4.531 },
    { age: 80, prixDeRente: 4.356 },
    { age: 81, prixDeRente: 4.087 },
    { age: 82, prixDeRente: 3.842 },
    { age: 83, prixDeRente: 3.597 },
    { age: 84, prixDeRente: 3.357 },
    { age: 85, prixDeRente: 3.120 },
    { age: 86, prixDeRente: 2.893 },
    { age: 87, prixDeRente: 2.678 },
    { age: 88, prixDeRente: 2.474 },
    { age: 89, prixDeRente: 2.279 },
    { age: 90, prixDeRente: 2.081 },
    { age: 91, prixDeRente: 1.894 },
    { age: 92, prixDeRente: 1.775 },
    { age: 93, prixDeRente: 1.633 },
    { age: 94, prixDeRente: 1.498 },
    { age: 95, prixDeRente: 1.371 },
    { age: 96, prixDeRente: 1.250 },
    { age: 97, prixDeRente: 1.136 },
    { age: 98, prixDeRente: 1.030 },
    { age: 99, prixDeRente: 0.933 },
    { age: 100, prixDeRente: 0.846 },
    { age: 101, prixDeRente: 0.766 },
    { age: 102, prixDeRente: 0.693 },
    { age: 103, prixDeRente: 0.626 },
    { age: 104, prixDeRente: 0.565 },
    { age: 105, prixDeRente: 0.509 },
    { age: 106, prixDeRente: 0.459 },
    { age: 107, prixDeRente: 0.413 },
    { age: 108, prixDeRente: 0.372 },
    { age: 109, prixDeRente: 0.335 },
    { age: 110, prixDeRente: 0.301 },
    { age: 111, prixDeRente: 0.270 },
    { age: 112, prixDeRente: 0.242 },
    { age: 113, prixDeRente: 0.217 },
    { age: 114, prixDeRente: 0.194 },
    { age: 115, prixDeRente: 0.174 },
    { age: 116, prixDeRente: 0.155 },
    { age: 117, prixDeRente: 0.138 },
    { age: 118, prixDeRente: 0.123 },
    { age: 119, prixDeRente: 0.109 },
    { age: 120, prixDeRente: 0.096 }
  ],
};

export const SMIGS_AFRIQUE_OUEST = {
  "Togo": [
    { anneeDebut: 2015, smig: 35000 },
    { anneeDebut: 2023, smig: 52500 }
  ],
  "Burkina Faso": [
    { anneeDebut: 2015, smig: 30000 },
    { anneeDebut: 2023, smig: 45000 }
  ],
  "Côte d'Ivoire": [
    { anneeDebut: 2015, smig: 60000 },
    { anneeDebut: 2023, smig: 75000 }
  ],
  "Sénégal": [
    { anneeDebut: 2015, smig: 47000 },
    { anneeDebut: 2023, smig: 52500 }
  ],
  "Guinée": [
    { anneeDebut: 2015, smig: 440000 },
    { anneeDebut: 2023, smig: 550000 }
  ],
  "Mali": [
    { anneeDebut: 2015, smig: 40000 },
    // Pas de changement de SMIG récent dans les données pour le Mali, donc une seule entrée
  ],
  // Ajoutez d'autres pays ici si besoin
};

export const CLE_REPARTITION_REVENUS = [
  {
    situation: "CONJOINT AVEC JUSQU’À 4 ENFANTS A CHARGE",
    ascendant: 5,
    conjoint: 40,
    enfant: 30,
    orphelinDouble: 50
  },
  {
    situation: "CONJOINT AVEC AU-DELA  DE  4 ENFANTS A CHARGE",
    ascendant: 5,
    conjoint: 35,
    enfant: 40,
    orphelinDouble: 50
  },
  {
    situation: "SANS CONJOINT ET SANS ENFANT",
    ascendant: 25,
    conjoint: 0,
    enfant: 0,
    orphelinDouble: 0
  },
  {
    situation: "AVEC CONJOINT(S) ET SANS ENFANT",
    ascendant: 15,
    conjoint: 40,
    enfant: 0,
    orphelinDouble: 0
  },
  {
    situation: "AVEC ENFANT(S) ET SANS CONJOINT",
    ascendant: 15,
    conjoint: 0,
    enfant: 50,
    orphelinDouble: 60
  }
];

export const BENEFICIAIRE_CLES = {
  "PERE": 75,
  "MERE": 75,
  "CONJOINT": 150,
  "CONCUBIN": 150,
  "CONCUBINE": 150,
  "ENFANT MINEUR": 100,
  "ENFANT_MINEUR": 100,
  "ENFANT MAJEUR": 75,
  "ENFANT_MAJEUR": 75,
  "FRERE": 50,
  "SOEUR": 50
};
